import { ChangeEvent } from 'react'
import { Search } from '@components/search'
import * as css from './style'

interface IProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  defaultValue?: string
}

export const Toolbar = ({ onChange, defaultValue }: IProps) => {
  return (
    <css.Toolbar>
      <Search onChange={onChange} defaultValue={defaultValue} />
    </css.Toolbar>
  )
}
